import React from 'react';
import { translate } from 'react-i18next';

import {Divider} from 'semantic-ui-react';

import {colors, fontSizes, fonts, spacings, layout} from 'style';
import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js';
import LoadInline from '../loading/LoadInline.js';

const style = {
    content: {
        ...fonts.body,
        lineHeight: '1.5',
    },
    body:{
        padding: spacings.base,
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        minHeight: 'calc(100% - 40px)',
        backgroundColor: 'white',
    },
    progressInfo: {
        paddingLeft: '80px',
        paddingRight: '80px',
        height: '40px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    progressContainer:{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: layout.screenWidth,
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
    },
    levelText: {
        paddingTop: '3px',
        fontWeight: 'light',
        fontSize: '0.95em',
        textAlign: 'center',
    },
    progressBar: {
        height: '12px',
        backgroundColor: '#fff',
    },
    section: {
        width: '100%',
        display: 'table',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        fontSize: '0.95em',
        opacity: '0.9',
        padding: '0px 0px 20px 0px',
    },
    divider: {
        padding:'0 0px 0px 20px',
        position: 'relative',
        display: 'table-cell',
        width: '100%',
    },
    image: {
        display: 'inline-block',
        height: '45px',
        width: '45px',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderRadius: '8px',
        marginRight: '20px',
    },
    completionInfo: {
        float: 'right',
        color: colors.themeLightBlue,
    },
    bullet: {
        color: colors.themeBlue,
        fontSize: '1.5em',
    },
    checkmark: {
        fontSize: '1.5em',
    },
    lock: {
        fontSize: '1.2em',
    },
    challenge: {
        position: 'relative',
        padding: '10px 0px 10px 0px',
        verticalAlign: 'middle',
        lineHeight: '50px',
        height: '70px',
    },
    challengeTitle: {
        position: 'relative',
        top: '-18px',
        marginBottom: '20px',
    },
    clickable: {
        cursor: 'pointer',
    },
    message: {
        textAlign: 'center',
        fontWeight: 'light',
        fontSize: '0.95em',
        paddingBottom: '25px',
    },
    messageIcon: {
    }
};

const Sections = ({t, busy, userCategory, sections, getChallengeImageUrl, onLaunchChallenge}) => (
    <div className="full-height" style={style.content}>
        {Boolean(userCategory && userCategory.categoryLevel) &&
            <div style={style.progressInfo}>
                <div style={style.progressContainer}>
                    <ProgressBar style={style.progressBar} value={userCategory.levelActivitiesCompleted} total={userCategory.categoryLevel.numRequired} borderWidth={'0'} />
                    <div style={style.levelText}>
                        {t('progress_{{completed}}_{{required}}_{{level}}',
                            {completed: userCategory.levelActivitiesCompleted,
                             required: userCategory.categoryLevel.numRequired,
                             level:userCategory.level})}
                    </div>
                </div>
            </div>
        }
        {busy && 
            <LoadInline centered vcentered /> 
        }
        <div style={style.body}>
        {sections.map(section =>(
            <div key={section.id}>
                <div style={style.section}>
                    {section.title} ({section.activitiesCompleted}/{section.numRequired}) 
                    <div style={style.divider}><hr/></div>
                </div>
                {section.message &&
                    <div style={style.message}>{section.message.label} <i style={{...style.messageIcon}} className={section.message.icon} /></div>
                }
                {!(section.collapse) && section.challenges.map(challenge => (
                    <div key={challenge.id} style={{...style.challenge, ...(challenge.locked ? {} : style.clickable)}} onClick={challenge.locked ? null : ()=>onLaunchChallenge(challenge)}>
                        <div style={{...style.image, backgroundImage:Utils.url(getChallengeImageUrl(challenge))}}/>
                        <span style={style.challengeTitle}>{challenge.title}</span>
                        {Boolean(challenge.locked && !challenge.activitiesCompleted) &&
                            <i style={{...style.completionInfo, ...style.lock}} className='icon-lock' />
                        }
                        {Boolean(challenge.activitiesCompleted==0 && !challenge.locked) &&
                            <i style={{...style.completionInfo, ...style.bullet}} className='icon-primitive-dot' />
                        }
                        {Boolean(challenge.activitiesCompleted==1) &&
                            <i style={{...style.completionInfo, ...style.checkmark}} className='icon-check2' />
                        }
                        {Boolean(challenge.activitiesCompleted>1) &&
                            <div style={style.completionInfo}>X{challenge.activitiesCompleted}</div>
                        }
                    </div>
                ))}
            </div>
        ))}
        </div>
    </div>
);

export default translate('categories')(Sections);



// WEBPACK FOOTER //
// ./src/modules/categories/Sections.js